
import {useParams} from 'react-router-dom'
import {useState,useEffect} from "react"
import axios from "axios"
import styled from "styled-components"
import {baseURL} from "../services/authentication.js"




const ReproductorContenedor=styled.div`
	background-size:cover;
	width:100vw;
	display:flex;
	flex-direction:column;
	height:80vh;
	justify-content:center;
	align-items:center
`



const ReproductorMin=styled.video`
	width:60vw;
	min-width:500px;
	border-radius:10px;
	@media (max-width:550px){
		min-width:300px;
		width:100vw}
`;

const TituloCompartido=styled.h1`
	font-size:44px;
	color:#f5b041;
	@media (max-width:550px){
		    font-size:25px;
		}
`;


export default  function ContainerCompartidoReproductor (){
	
	const [data,setData]=useState();
	const params=useParams(); 
	let {id,token}=params;

		
	useEffect(()=>{
		
	
				
		axios(baseURL+`/farmasistutorials?id=${id}`,
				{headers:{ Authorization:`Bearer ${token}`} } )
		.then(res=>res.data)
		.then(res=>setData(res))
		.catch(err=>console.log(err.message))

	
	},[params.id,id,token])		

	return(
		<ReproductorContenedor>		
			{data?<TituloCompartido>{data.name}</TituloCompartido>:null}
			{data?<ReproductorMin  controls="controls" src={data.video}/>:null}
		</ReproductorContenedor>
	)

}